import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentTransportOrderCommentsFacade } from './shipment-transport-order-comments.facade';
import { TransportOrderIdView } from '../../../../models';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentTransportOrderCommentsGuard {
  constructor(
    private shipmentTransportOrderCommentsFacade: ShipmentTransportOrderCommentsFacade,
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      switchMap((identifier: TransportOrderIdView) => {
        this.shipmentTransportOrderItemFacade.loadShipmentTransportOrderNotificationListCount(identifier);

        return checkStoreState(this.shipmentTransportOrderCommentsFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderCommentsFacade);
  }
}
